import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { BasicService } from '../../services/basic.service';
import { ConfirmDialogData } from '../confirm-dialog/confirm-dialog-data.interface';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { ProgressionDialogData } from './progression-dialog-data.model';

@Component({
  selector: 'app-progression-dialog',
  templateUrl: './progression-dialog.component.html',
  styleUrls: ['./progression-dialog.component.scss'],
})
export class ProgressionDialogComponent implements OnInit, AfterViewInit {
  @Input() data: ProgressionDialogData;
  @Output() closeDialog = new EventEmitter();
  @ViewChild('progressDialogTplRef') progressDialogTplRef: TemplateRef<any>;

  constructor(private basicService: BasicService, public dialog: MatDialog) {}

  ngOnInit(): void {
    this.data.updateProgression.subscribe(() => {
      this.updateProgression();
    });
  }

  ngAfterViewInit() {
    const data: ConfirmDialogData = {
      title: this.data.title,
      description: '',
      templateRef: this.progressDialogTplRef,
      confirmBtnText: this.basicService.translate('ok'),
      cancelBtnText: '',
      disable: () => this.data.isLoading,
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      panelClass: 'medium-size',
      data,
    });

    dialogRef.afterClosed().subscribe(() => {
      this.closeDialog.emit();
    });
  }

  private updateProgression() {
    this.data.progressionPercentage = (this.data.done / this.data.total) * 100;
  }
}
